module.exports = __webpack_public_path__ + "img/talk-sport.f4ef0495.png";